var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavStakesayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.33333 4C9.36092 4.05223 11.3426 3.39167 12.9333 2.13333C13.0324 2.05905 13.1502 2.01381 13.2735 2.00269C13.3968 1.99157 13.5207 2.01501 13.6315 2.07038C13.7422 2.12575 13.8353 2.21086 13.9004 2.31618C13.9655 2.4215 14 2.54286 14 2.66667V10.6667C14 10.7905 13.9655 10.9118 13.9004 11.0172C13.8353 11.1225 13.7422 11.2076 13.6315 11.263C13.5207 11.3183 13.3968 11.3418 13.2735 11.3306C13.1502 11.3195 13.0324 11.2743 12.9333 11.2C11.3426 9.94166 9.36092 9.2811 7.33333 9.33333H3.33333C2.97971 9.33333 2.64057 9.19286 2.39052 8.94281C2.14048 8.69276 2 8.35362 2 8V5.33333C2 4.97971 2.14048 4.64057 2.39052 4.39052C2.64057 4.14048 2.97971 4 3.33333 4H7.33333Z",
    stroke: "#525252",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4 9.33333C4 11.0643 4.56142 12.7486 5.6 14.1333C5.81217 14.4162 6.12804 14.6033 6.4781 14.6533C6.82817 14.7033 7.18377 14.6122 7.46667 14.4C7.74956 14.1878 7.93659 13.872 7.9866 13.5219C8.03661 13.1718 7.94551 12.8162 7.73333 12.5333C7.04095 11.6102 6.66667 10.4873 6.66667 9.33333",
    stroke: "#525252",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.33333 4V9.33333",
    stroke: "#525252",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavStakesayIcon);
export default __webpack_public_path__ + "static/media/nav-stakesay-icon.da150336f28e697ffe4ce503f974a4f8.svg";
export { ForwardRef as ReactComponent };